const Favorite = () => {
    return (
        <>
            <svg
                width="33"
                height="34"
                viewBox="0 0 33 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    cx="16.5"
                    cy="17"
                    r="16"
                    stroke="var(--color-ec-border)"
                />
                <path
                    d="M16.625 12.125L16.9688 12.5L17.3438 12.125C17.8854 11.6042 18.4896 11.2396 19.1562 11.0312C19.8438 10.8229 20.5521 10.7708 21.2812 10.875C22.3646 11.0833 23.25 11.5938 23.9375 12.4062C24.625 13.1979 24.9792 14.1562 25 15.2812V15.4688C24.9792 16.8229 24.4792 17.9583 23.5 18.875L17.875 24.1562C17.625 24.3854 17.3333 24.5 17 24.5C16.6667 24.5 16.375 24.3854 16.125 24.1562L10.5 18.875C9.52083 17.9583 9.02083 16.8229 9 15.4688V15.2812C9.02083 14.1562 9.375 13.1979 10.0625 12.4062C10.75 11.5938 11.6354 11.0833 12.7188 10.875C13.4271 10.7708 14.125 10.8229 14.8125 11.0312C15.5 11.2396 16.1042 11.6042 16.625 12.125C16.6042 12.125 16.6042 12.125 16.625 12.125ZM16.9688 14.625L15.5625 13.1562C14.8333 12.4896 13.9688 12.2188 12.9688 12.3438C12.2396 12.4896 11.6458 12.8333 11.1875 13.375C10.75 13.9167 10.5208 14.5521 10.5 15.2812V15.4688C10.5208 16.3854 10.8542 17.1562 11.5 17.7812L17 22.9062L22.5 17.7812C23.1458 17.1562 23.4792 16.3854 23.5 15.4688V15.2812C23.4792 14.5521 23.2396 13.9167 22.7812 13.375C22.3438 12.8333 21.7604 12.4896 21.0312 12.3438C20.0312 12.2188 19.1667 12.4896 18.4375 13.1562L16.9688 14.625Z"
                    fill="var(--color-ec-body)"
                />
            </svg>
        </>
    );
};

export default Favorite;
